// src/pages/cobranzas/DetalleCobranzas2.jsx
import React, { useState } from 'react';
import AuthUser from '../../../components/AuthUser';
import { ItemsCobranzas2 } from './ItemsCobranzas2';
import Pagination from 'react-responsive-pagination';
import { ItemsCobranzasMobile } from './ItemsCobranzasMobile';
import { CobranzaPDF } from '../../PDF/CobranzaPDF';
import { getVendedor } from '../../../api/request';
import { getDetallesCobranzas } from '../../../api/requestCobranzas';
import { Modal } from 'react-bootstrap';
import { Dropdown, ButtonToolbar } from 'rsuite';
import { RiCloseCircleFill } from 'react-icons/ri';
import { SlOptionsVertical } from 'react-icons/sl';
import { AiFillEye } from 'react-icons/ai';

export const DetalleCobranzas2 = ({ item: Cobranzas }) => {
  const { user } = AuthUser();

  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [detalleCobranza, setDetalleCobranza] = useState([]);
  const [vendedor, setVendedor] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [urlPage, setUrlPage] = useState('');

  const handleShow = async () => {
    setFullscreen(true);
    setShow(true);
    await loadDetallesCobranzas2();
  };

  const loadDetallesCobranzas2 = async (pageNum = 1) => {
  setLoading(true);
  try {
    const res = await getDetallesCobranzas(Cobranzas.Documento, pageNum);
    const body = res?.data ? res : (res ?? {});
    const normalized = body.data ? {
      current_page: body.meta?.current_page ?? body.current_page,
      last_page: body.meta?.last_page ?? body.last_page,
      first_page_url: body.links?.first ?? body.first_page_url,
      links: body.links ?? body.links,
      data: body.data
    } : { data: [] };

    // vendedor: preferimos el nombre que ya viene con la cabecera (Cobranzas.Nombre)
    if (Cobranzas?.Nombre) {
      setVendedor(Cobranzas.Nombre);
    } else {
      try {
        const vend = await getVendedor(Cobranzas.Usuario);
        setVendedor(vend?.[0]?.Nombre ?? '');
      } catch (err) {
        console.warn('getVendedor warning:', err);
        setVendedor('');
      }
    }

    setPage(Number(normalized.current_page ?? 1));
    setTotalPages(Number(normalized.last_page ?? 1));
    setUrlPage(normalized.first_page_url ?? '');
    setDetalleCobranza(normalized.data ?? []);
  } catch (err) {
    console.error('loadDetallesCobranzas2 error:', err);
    setDetalleCobranza([]);
  } finally {
    setLoading(false);
  }
};


  const handlePageChangeDetails = async (pageNum) => {
  setPage(pageNum);

  // si tenemos urlPage y es un link paginado del backend, construimos nextUrl
  if (urlPage) {
    try {
      const nextUrl = urlPage.includes('?')
        ? urlPage.replace(/([?&]page=)\d+/, `$1${pageNum}`)
        : `${urlPage}?page=${pageNum}`;

      const resp = await fetch(nextUrl);
      const json = await resp.json();
      // normalize same way as loadDetallesCobranzas2 expects
      const body = json?.data ? json : (json ?? {});
      const normalized = body.data ? {
        current_page: body.meta?.current_page ?? body.current_page,
        last_page: body.meta?.last_page ?? body.last_page,
        first_page_url: body.links?.first ?? body.first_page_url,
        links: body.links ?? body.links,
        data: body.data
      } : { data: [] };

      setDetalleCobranza(normalized.data ?? []);
      setPage(Number(normalized.current_page ?? pageNum));
      setTotalPages(Number(normalized.last_page ?? 1));
      setUrlPage(normalized.first_page_url ?? urlPage);
    } catch (err) {
      console.error('handlePageChangeDetails fetch error:', err);
    }
  } else {
    // fallback: volver a solicitar a la API con page param
    await loadDetallesCobranzas2(pageNum);
  }
};




  return (
    <>
      <tr className="d-none-table">
        <td className="text-danger fw-bold text-center">{Cobranzas.Documento}</td>
        <td>{Cobranzas.NombreCliente}</td>
        {user.CodGerente !== null && <td className="d-md-block-table d-none-table fw-bold text-belmeny text-center">{Cobranzas.Nombre}</td>}
        <td className="text-success fw-bold text-center">${Number(Cobranzas.TotalCobranza || 0).toFixed(2)}</td>
        <td className="d-mb-block-table d-none-table text-center">{new Date(Cobranzas.FechaCobranza).toLocaleDateString('es-MX')}</td>
        <td className="text-center">
          <button className="btn btn-success btn-sm my-2 w-100" onClick={handleShow}>Ver detalles</button>
          
        </td>
      </tr>

      {/* Mobile card omitted for brevity — copy same pattern from existing component but using safe Number(...).toFixed(2) */}
      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header className="bg-belmeny text-light">
          <Modal.Title className="fst-italic">Información de la cobranza: {Cobranzas.Documento}</Modal.Title>
          <Modal.Title>
            <RiCloseCircleFill className="text-danger fs-1 modal-close bg-light rounded-circle" onClick={() => setShow(false)} />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="container-fluid">
            {loading ? (
              <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <span className="loader-cobranzas" />
              </div>
            ) : (
              <>
                {/* Desktop view (copy your layout but protect values) */}
                <div className="d-none d-md-block">
                  <h3 className="bg-belmeny text-light rounded-pill text-center w-50 m-auto py-1 mb-3">Vendedor Encargado: {vendedor}</h3>
                  <div className="row badge-vendedor rounded-pill">
                    <div className="col">
                      <h4 className="text-center">RIF: {Cobranzas.CodCliente}</h4>
                      <h3 className="text-center">{Cobranzas.NombreCliente}</h3>
                    </div>
                  </div>
                         <div className="row my-3 text-center">
                        <div className="col">
                          <h5>Documento afectado: <span className="text-danger">{Cobranzas.DocumentoAfectado}</span></h5>
                        </div>
                        <div className="col">
                          <h5>Responsable: {(Cobranzas.Responsable === '') ? <>N/A</> : <>{Cobranzas.Responsable}</>}</h5>
                        </div>
                        <div className="col">
                          <h5>Comentarios: {(Cobranzas.Comentarios === '') ? <>No se agregaron comentarios</> : <>{Cobranzas.Comentarios}</>}</h5>
                        </div>
                      </div>
                  <table className="table table-responsive table-bordered table-hover border-belmeny my-3 fs-5 text-center">
                    <thead className="bg-belmeny text-light">
                      <tr>
                        <th>Referencia</th>
                        <th>Forma de Pago</th>
                        <th>Banco</th>
                        <th>Fecha del Pago</th>
                        <th>Monto</th>
                        <th>Recibo</th>
                        <th>Tasa</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detalleCobranza.map(item => <ItemsCobranzas2 item={item} key={item.DocumentoFormaPago} />)}
                    </tbody>
                  </table>
              
                  <Pagination total={totalPages} current={page} onPageChange={handlePageChangeDetails} />
                </div>

                {/* Mobile: similar pattern */}
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
